<plyca-ui-filter-generic
  [config]="{
    model: model,
    hasHeader: true,
    formConfigFilters: formConfigFilters,
    jsonFile: 'catalogProject/catalogProjectFilterCartSettings.json'
  }"
  (valuesFormChange)="valuesOnChange($event)"
>
  <sub-header [isModal]="true" [windowHash]="filterWindowHash" [includeContextHelp]="false"></sub-header>
</plyca-ui-filter-generic>
